"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @mui
const GlobalStyles_1 = __importDefault(require("@mui/material/GlobalStyles"));
// ----------------------------------------------------------------------
function GlobalStyles() {
    const inputGlobalStyles = ((0, jsx_runtime_1.jsx)(GlobalStyles_1.default, { styles: {
            '*': {
                boxSizing: 'border-box',
            },
            html: {
                margin: 0,
                padding: 0,
                width: '100%',
                height: '100%',
                WebkitOverflowScrolling: 'touch',
            },
            body: {
                margin: 0,
                padding: 0,
                width: '100%',
                height: '100%',
            },
            '#root': {
                width: '100%',
                height: '100%',
            },
            input: {
                '&[type=number]': {
                    MozAppearance: 'textfield',
                    '&::-webkit-outer-spin-button': {
                        margin: 0,
                        WebkitAppearance: 'none',
                    },
                    '&::-webkit-inner-spin-button': {
                        margin: 0,
                        WebkitAppearance: 'none',
                    },
                },
            },
            img: {
                display: 'block',
                maxWidth: '100%',
            },
            ul: {
                margin: 0,
                padding: 0,
            },
        } }));
    return inputGlobalStyles;
}
exports.default = GlobalStyles;
